import {User, UserAttributes} from './user.model';
import {UserRole} from '../../auth/rbac/user-role.enum';
import {UserType} from './user-type.model';
export class UserUtils {
  static getPublisherId(user: User) {
    if (user.attributes) {
      const found = user.attributes.find(a => a.name.includes(UserAttributes.PUBLISHER_ID));
      return found ? found.value : null;
    }
    return null;
  }

  static getDemandPartnerId(user: User) {
    if (user.attributes) {
      const found = user.attributes.find(a => a.name.includes(UserAttributes.DEMAND_PARTNER_ID));
      return found ? found.value : null;
    }
    return null;
  }

  static hasRole(user: User, role: UserRole) {
    return !user.roles || user.roles.indexOf(role.toString()) !== -1;
  }

  static isPublisher(user: User) {
    return UserUtils.hasRole(user, UserRole.PUBLISHER);
  }

  static isDemandPartner(user: User) {
    return UserUtils.hasRole(user, UserRole.DEMAND_PARTNER);
  }

  static isKitchenUser(user: User) {
    return UserUtils.hasRole(user, UserRole.CM_USER);
  }

  static setType(user: User) {
    if (UserUtils.hasRole(user, UserRole.CM_USER)) {
      user._type = UserType.CM_USER;
    }
    if (UserUtils.hasRole(user, UserRole.PUBLISHER)) {
      user._type = UserType.PUBLISHER;
    }
    if (UserUtils.hasRole(user, UserRole.DEMAND_PARTNER)) {
      user._type = UserType.DEMAND_PARTNER;
    }
  }

  static setProperty(user: User) {
    UserUtils.setType(user);
    switch (user._type) {
      case UserType.CM_USER:
        user._property = 'Kitchen';
        break;
      case UserType.PUBLISHER:
        user._property = user.publisher ? user.publisher.name : '';
        break;
      case UserType.DEMAND_PARTNER:
        user._property = user.demandPartner ? user.demandPartner.name : '';
        break;
    }
  }

  static setRoles(user: User) {
    user._roles = user.roles.filter(role => ![UserRole.CM_USER, UserRole.DEMAND_PARTNER, UserRole.PUBLISHER].includes(<UserRole>role))
      .map(role => <UserRole> role)
  }

  static unpack(user: User) {
    if (!user) return;
    UserUtils.setType(user);
    UserUtils.setProperty(user);
    UserUtils.setRoles(user);
  }


  static pack(user: User) {
    user.username = user.email;
    user.roles = [<UserRole>user._type.toString()].concat(user._roles).map(role => role.toString());
    user.companyId = '059fd413-c05d-4b80-b5a2-1f9a72b8ae04';
    user.attributes = [{name: 'companyId', value: user.companyId}];
    switch (user._type) {
      case UserType.PUBLISHER: {
        const attr = user.attributes.find(a => a.name === 'publisherId');
        if (attr) {
          attr.value = user.publisherId
        } else {
          user.attributes.push({
            name: 'publisherId',
            value: user.publisherId
          });
        }
        break;
      }
      case UserType.DEMAND_PARTNER: {
        const attr = user.attributes.find(a => a.name === 'demandPartnerId');
        if (attr) {
          attr.value = user.demandPartnerId
        } else {
          user.attributes.push({
            name: 'demandPartnerId',
            value: user.demandPartnerId
          });
        }
        break;
      }
    }
  }
}
